import React from "react";
import "../pages/styles/home.css";
import logo from "../Assets/images/PM-Champions-Red-bg.webp";

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <div>
      <div className="copyrights">
        <img src={logo} style={{ width: "30px", objectFit: "contain" }} />
        <p>{`© ${year} PM Champions, LLC - Roshpit Champions II`}</p>
      </div>
    </div>
  );
};

export default Footer;
